import React from 'react';
import {SortCollection} from '..';

export interface ReduxSortableProps {
    defaultSort?: SortCollection
}

export const ReduxSortable: React.FunctionComponent<ReduxSortableProps> = () => null;